import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "../assets/lang/ru";
import kz from "../assets/lang/kz";
import {COOKIE_KEY, LANG_KEY} from "../constants";
import {Cookies} from "react-cookie";

const cookies = new Cookies()

const cookiesLang = cookies.get(COOKIE_KEY.LANG)

const resources = {
  [LANG_KEY.RU]: ru,
  [LANG_KEY.KZ]: kz,
}

i18n
  .use(initReactI18next)
  .init({
    resources: resources,
    // debug: process.env.NODE_ENV !== "production",
    debug: process.env.NODE_ENV !== "production",
    lng: cookiesLang ? cookiesLang : LANG_KEY.RU,
    fallbackLng: cookiesLang ? cookiesLang : LANG_KEY.RU,
    defaultNS: "common",
    ns: "common",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
